import React, { useEffect, useRef, useState } from "react";
import { Upload } from "antd";
import "./MultiFileUpload.css";
import { useParams } from "react-router";
import checkFileName from "../../utils/checkSpecialCharacter";
export const MultipleFileUpload = ({
  label = "",
  name = "",
  register,
  errors,
  fileTypes = "",
  linkAction = "",
  linkContext = "",
  subLabel = "",
  additionalcomments = "",
  requiredLable = false,
  mode,
}) => {
  const [fileList, setFileList] = useState([]);
  const [characterError, setCharacterError] = useState({
    multiple_file_upload: false,
    multiple_file_uploadName: "",
  });
  const { onChange } = register(name);

  const params = useParams();

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem(params.applicationID)) || {};
    if (savedData[`${name}filedisplay`]) {
      setFileList(savedData[`${name}filedisplay`]);
    }
  }, [params.applicationID, name]);

  const handleFileChange = (info) => {
    console.log(info);
    let updatedFileList = [...info.fileList];

    if (info.file.status === "removed") {
      updatedFileList = updatedFileList.filter((file) => file.uid !== info.file.uid);
    }

    const filesToStore = updatedFileList.map((file) => ({
      ...file,
      originFileObj: undefined,
    }));

    const savedData = JSON.parse(localStorage.getItem(params.applicationID)) || {};
    savedData[name] = updatedFileList;
    savedData[`${name}filedisplay`] = filesToStore;

    localStorage.setItem(params.applicationID, JSON.stringify(savedData));

    // Validate file names
    const validFiles = updatedFileList.filter((file) => checkFileName(file.name));
    setCharacterError({
      multiple_file_upload: validFiles.length !== updatedFileList.length,
      multiple_file_uploadName: validFiles.length !== updatedFileList.length ? "Invalid characters in file names." : "",
    });

    setFileList(validFiles);
    const registerFiles = validFiles.map((file) => file.originFileObj);
    onChange({ target: { name, value: registerFiles } });
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  return (
    <>
      <label className="form-label">
        {label}
        {requiredLable && <small className="text-danger ms-1">*</small>}
      </label>
      {linkContext && (
        <a href={linkAction} target="_blank" rel="noopener noreferrer">
          {linkContext}
        </a>
      )}
      {subLabel && <label className="form-label">{subLabel}</label>}
      <Upload
        id="multiple_file_upload"
        customRequest={dummyRequest}
        accept=".pdf, .cad"
        multiple={mode}
        onChange={handleFileChange}
        fileList={fileList}
        showUploadList={{ showRemoveIcon: true }}
        className="upload-list-inline"
      >
        <div className="input-group mb-3 multi-fileupload">
          <div className="fileupload">
            <label htmlFor="files">Choose or Drag multiple files</label>
          </div>
          {fileTypes && (
            <span className="input-group-text bg-secondary text-dark" id="basic-addon2">
              .pdf or .cad up to 100 MB
            </span>
          )}
          <span className="text-danger">
            {errors[name] && <span>Select a valid file for {label}</span>}
            {characterError.multiple_file_upload && <span className="text-sm">Remove special characters from file names. Allowed special characters are - and _</span>}
          </span>
        </div>
        {additionalcomments && <div className="form-text mb-3">{additionalcomments}</div>}
      </Upload>
    </>
  );
};
